<div class="se-autocomplete-component">
    <mat-form-field style="width: 100%" [floatLabel]="isWithLabel ? 'auto' : 'never'">
        <mat-label *ngIf="isWithLabel">{{ placeholder }}</mat-label>

        <input
            #textInput
            type="text"
            autocomplete="off"
            [required]="required"
            [placeholder]="placeholder"
            matInput
            [(ngModel)]="value"
            [formControl]="formControl"
            [matAutocomplete]="auto"
            [errorStateMatcher]="seAutocompleteMatcher"
            (keyup.enter)="addOption()"
        />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event.option)">
            <mat-option
                class="se-autocomplete-mat-option"
                *ngFor="let option of filteredOptions | async"
                [value]="option"
                (mousedown)="emitOptionValue(option)"
            >
                {{ option }}
            </mat-option>
        </mat-autocomplete>

        <mat-icon *ngIf="icon" matSuffix [matTooltip]="iconTooltip ?? ''">{{ icon }}</mat-icon>

        <button
            matSuffix
            mat-button
            mat-icon-button
            (click)="addOption()"
            *ngIf="dynamicAddEnabled && showAddButton && formControl.value"
        >
            <mat-icon matTooltip="Add &quot;{{ formControl.value }}&quot;">add</mat-icon>
        </button>
        <mat-error *ngIf="isOnError">{{ getErrorMessage() }}</mat-error>
    </mat-form-field>
</div>
